import type { NaturezaAcaoOption } from '../pages/relatorio-civel-page.models';

type TipoMovimentacaoOpcao = {
  id: number;
  descricao?: string;
  nucleo?: boolean;
  relatorioCivel?: boolean;
  relatorioCriminal?: boolean;
};

export function opcoesNaturezaFromTipos(tipos: TipoMovimentacaoOpcao[]): NaturezaAcaoOption[] {
  return [
    { value: '', label: 'Selecione...' },
    ...tipos.map((tipo) => ({
      value: String(tipo.id),
      label: tipo.descricao || '',
      nucleo: tipo.nucleo,
      relatorioCivel: tipo.relatorioCivel,
      relatorioCriminal: tipo.relatorioCriminal,
    })),
  ];
}

export function filtrarOpcoesTipoRecurso(
  opcoes: NaturezaAcaoOption[],
  criminal: boolean,
): NaturezaAcaoOption[] {
  return opcoes.filter(
    (option) =>
      !option.value || (criminal ? option.relatorioCriminal === true : option.relatorioCivel === true),
  );
}

export function rotuloTipoRecurso(
  valor: string,
  opcoes: NaturezaAcaoOption[],
  naturezaAcaoOptions: NaturezaAcaoOption[],
): string {
  return (
    opcoes.find((option) => option.value === valor)?.label ||
    naturezaAcaoOptions.find((option) => option.value === valor)?.label ||
    valor
  );
}

export function garantirOpcaoTipoRecurso(
  opcoes: NaturezaAcaoOption[],
  valor: string | undefined,
  naturezaAcaoOptions: NaturezaAcaoOption[],
): NaturezaAcaoOption[] {
  const atual = valor?.trim();
  if (!atual || opcoes.some((option) => option.value === atual)) {
    return opcoes;
  }
  return [...opcoes, { value: atual, label: rotuloTipoRecurso(atual, opcoes, naturezaAcaoOptions) }];
}
